<template>
  <div class="page-container">
    <el-card>
      <!-- 搜索区 -->
      <div class="search-bar">
        <el-input
          v-model="query.phone"
          placeholder="搜索用户手机号"
          clearable
          style="width:180px"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.status" placeholder="使用状态" clearable style="width:120px">
          <el-option label="未使用" :value="0" />
          <el-option label="已使用" :value="1" />
          <el-option label="冻结" :value="2" />
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 表格 -->
      <el-table :data="tableData" v-loading="loading" border stripe style="width:100%">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="优惠券名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.coupon">{{ row.coupon.name }}</span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="立减金额" width="110" align="right">
          <template slot-scope="{ row }">
            <span v-if="row.coupon" class="val-primary">¥{{ Number(row.coupon.amount).toFixed(2) }}</span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="row.coupon">{{ row.coupon.started_at }} ~ {{ row.coupon.expired_at }}</span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="130">
          <template slot-scope="{ row }">
            <span v-if="row.member && row.member.phone">{{ row.member.phone }}</span>
            <span v-else class="text-muted">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.member && row.member.nickname">{{ row.member.nickname }}</span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="使用状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.status)" size="small">
              {{ statusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="发放时间" width="160" />
        <el-table-column label="使用时间" width="160">
          <template slot-scope="{ row }">
            <span v-if="row.used_at">{{ row.used_at }}</span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="query.page"
        :page-sizes="[10, 15, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top:16px;text-align:right"
        @size-change="val => { query.pageSize = val; fetchData() }"
        @current-change="val => { query.page = val; fetchData() }"
      />
    </el-card>
  </div>
</template>

<script>
import { getCouponRecords } from '@/api/coupon'

const STATUS_MAP = {
  0: { label: '未使用', type: 'info' },
  1: { label: '已使用', type: 'success' },
  2: { label: '冻结',   type: 'warning' }
}

export default {
  name: 'CouponRecords',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        page: 1,
        pageSize: 15,
        phone: '',
        status: ''
      }
    }
  },
  created() { this.fetchData() },
  activated() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page:     this.query.page,
          pageSize: this.query.pageSize
        }
        if (this.query.phone)         params.phone  = this.query.phone
        if (this.query.status !== '') params.status = this.query.status
        const res = await getCouponRecords(params)
        const d = res.data || {}
        this.tableData = d.data || d.list || []
        this.total = d.total || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.query.page = 1; this.fetchData() },
    handleReset() {
      this.query = { page: 1, pageSize: 15, phone: '', status: '' }
      this.fetchData()
    },
    statusLabel(status) { return (STATUS_MAP[status] || {}).label || '—' },
    statusType(status)  { return (STATUS_MAP[status] || {}).type  || 'info' }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.text-muted  { color: #c0c4cc; font-size: 12px; }
.val-primary { color: #f56c6c; font-weight: 600; }
</style>
